import { Container } from '@plone/components';
import Image from '@plone/volto/components/theme/Image/Image';
import Logo from '@plone/volto/components/theme/Logo/Logo';
import SlotRenderer from '@plone/volto/components/theme/SlotRenderer/SlotRenderer';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { shallowEqual, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import FooterLinks from './FooterLinks';

const messages = defineMessages({
  allRights: {
    id: 'all-rights',
    defaultMessage: 'All rights reserved',
  },
  home: {
    id: 'Home',
    defaultMessage: 'Home',
  },
});

const Footer = () => {
  const intl = useIntl();
  const { content } = useSelector(
    (state) => ({
      content: state.content.data,
    }),
    shallowEqual,
  );
  const location = useLocation();
  const footerSettings = useSelector(
    (state) =>
      state.content.data?.['@components']?.inherit?.['voltolighttheme.footer']
        ?.data,
  );
  const footerLinks = footerSettings?.footer_links;
  const footerLogo = content?.footer_logo;

  return (
    <footer id="footer">
      <SlotRenderer name="preFooter" content={content} location={location} />

      <Container className="footer">
        {(footerLinks ?? []).length > 0 && <FooterLinks links={footerLinks} />}
        <section className="logo">
          {footerLogo ? (
            <Link to={'/'} aria-label={intl.formatMessage(messages.home)}>
              <Image
                className="ui image"
                src={flattenToAppURL(footerLogo?.download)}
              />
            </Link>
          ) : (
            <Logo />
          )}
        </section>
        <section className="email">
          <a href="mailto:politicamunicipal@junts.cat">
            politicamunicipal@junts.cat
          </a>
        </section>
        <section className="copyright">
          <p>
            {intl.formatMessage(messages.allRights)}&nbsp;
            {new Date().getFullYear()}&nbsp;©
          </p>
          <p>Junts per Catalunya</p>
        </section>
      </Container>
    </footer>
  );
};

export default Footer;
